<template>
  <div class="clerk-home">
    <div class="header">
      <div class="role-badge">店员模式</div>
      <div class="greeting">店员工作台</div>
      <!-- <div class="store-name">{{ storeName }}</div> -->
    </div>
    <div class="action-cards">
      <div class="action-card" @click="goActivate">
        <div class="card-icon">
          <van-icon name="scan" size="36" color="#1890ff" />
        </div>
        <div class="card-name">设备激活</div>
        <div class="card-desc">扫描IMEI激活设备</div>
      </div>
      <div class="action-card" @click="goAfterSale">
        <div class="card-icon">
          <van-icon name="service-o" size="36" color="#52c41a" />
        </div>
        <div class="card-name">售后服务</div>
        <div class="card-desc">换机/换屏/延保等</div>
      </div>
      <div class="action-card" @click="goChangeImei">
        <div class="card-icon">
          <van-icon name="replay" size="36" color="#fa8c16" />
        </div>
        <div class="card-name">更换串号</div>
        <div class="card-desc">已激活设备换号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClerkHome',
  data() {
    return {
      storeName: '深圳南山旗舰店',
    }
  },
  mounted() {
    const userInfo = this.$store.state.userInfo
    if (userInfo && userInfo.storeName) {
      this.storeName = userInfo.storeName
    }
  },
  methods: {
    goActivate() {
      this.$router.push({ path: '/Oppo/Activate' })
    },
    goAfterSale() {
      this.$toast('售后服务功能即将上线')
    },
    goChangeImei() {
      this.$toast('更换串号功能即将上线')
    },
  },
}
</script>

<style lang="less" scoped>
.clerk-home {
  min-height: 100vh;
  background: #f5f5f5;

  .header {
    background: linear-gradient(135deg, #722ed1, #1890ff);
    padding: 60px 32px 40px;
    text-align: center;
    color: #fff;

    .role-badge {
      display: inline-block;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 20px;
      padding: 4px 20px;
      font-size: 24px;
      margin-bottom: 16px;
    }

    .greeting {
      font-size: 48px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    .store-name {
      font-size: 28px;
      opacity: 0.85;
    }
  }

  .action-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 30px 24px;

    .action-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px 16px;
      text-align: center;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      cursor: pointer;
      transition: transform 0.15s, box-shadow 0.15s;

      &:active {
        transform: scale(0.97);
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
      }

      .card-icon {
        margin-bottom: 16px;
      }

      .card-name {
        font-size: 28px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 8px;
      }

      .card-desc {
        font-size: 22px;
        color: #999;
        line-height: 1.4;
      }
    }
  }
}
</style>
